
import { defineComponent, onMounted, ref } from "vue";
import { useApi } from "~/composable/useApi";
import RemainingProofreaderCountsRepository from "~/repositories/users/RemainingProofreaderCountsRepository";

export default defineComponent({
  name: "ModalAiProofreader",
  setup(props, { emit }) {
    onMounted(async () => {
      await fetchRemainingProofreaderCount();
    });
    const remainingProofreaderCount = ref(0);
    const fetchRemainingProofreaderCount = async () => {
      await fetchRemainingProofreaderCountApi();
    };
    const {
      handleApi: fetchRemainingProofreaderCountApi,
    } = useApi(async () => {
      const repository = new RemainingProofreaderCountsRepository();
      remainingProofreaderCount.value = await repository.show();
    });

    const close = () => {
      emit("close");
    };

    const submit = () => {
      emit("submit");
    };

    return {
      remainingProofreaderCount,
      close,
      submit
    };
  }
});
